import { render, staticRenderFns } from "./TrainConfigurations.vue?vue&type=template&id=8628caea&scoped=true"
import script from "./TrainConfigurations.vue?vue&type=script&lang=js"
export * from "./TrainConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8628caea",
  null
  
)

export default component.exports